// extracted by mini-css-extract-plugin
export default {"main":"PayPal_main__Piydp","modal":"PayPal_modal__WHj+K"};